import React, { useEffect, useState } from "react";
import eyeIcon from "../../../assets/icons/eyeicon.svg";
import { Link } from "react-router-dom";
import paymentIcon from "../../../assets/icons/payment-svg.svg";
import shareIcon from "../../../assets/icons/share-links-svgrepo-com.svg";
import { api } from "../../../utils/axios/Config";
import {
  handleErrorApi,
  toLocaleStringFormatter,
  unixToPersianDay,
  getImage,
} from "../../../utils/utils";

import { RWebShare } from "react-web-share";
import Loader from "../../shared/Loader";
import PaymentLinkPrint from "../../shared/PaymentLinkPrint";
import copy from "../../../assets/icons/copy.svg";
import Switch from "../../shared/Checkbox/Switch";
import { toast } from "react-toastify";

const PaymentLinkCard2 = ({ rowData, refetch }) => {
  const { form } = rowData;
  const linkIsValid =
    form?.approval_status !== "approved" && form?.active && !form?.banned;
  const formIsBanned = form?.banned;
  const formIsExpired = form?.expire_time < Date.now() / 1000;

  const [qrCode, setQrCode] = useState(null);
  const [loadingQRImage, setLoadingQRImage] = useState(false);
  const [formStats, setFormStats] = useState({
    status: form?.approval_status,
    active: form?.active,
  });

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };

  useEffect(() => {
    const handleGetQRCode = async () => {
      setLoadingQRImage(true);
      try {
        const response = await api.post(
          `/generals/generate/qrcode/`,
          {
            link: `${import.meta.env.VITE_FORM_URL}/f/${form?.link}`,
          },
          { responseType: "blob" },
        );

        const base64QR = await convertBlobToBase64(response.data);

        setQrCode(base64QR);

        setLoadingQRImage(false);
      } catch (error) {
        handleErrorApi(error);

        setLoadingQRImage(false);
      }
    };
    handleGetQRCode();

    return () => {};
  }, []);

  const handleLink = async (formLink) => {
    try {
      const response = await api.get(`/forms/link/${formLink}/exists/`);
      if (response?.data?.result) {
        window.open(`${import.meta.env.VITE_FORM_URL}/f/${formLink}`, "_blank");
      }
    } catch (error) {
      handleErrorApi(error);
    }
  };
  return (
    <div className="bg-primary-20 p-4 rounded-[16px] flex flex-col gap-1 md:gap-4  items-center shadow-lg border  ">
      <div className="flex justify-between items-center w-full">
        <div className=" flex-center items-top gap-2  text-dark  ">
          <img
            src={
              form?.image_preview ? getImage(form?.image_preview) : paymentIcon
            }
            width={32}
            height={32}
            alt=""
            className="white-img rounded-lg min-w-[32px] min-h-[32px] max-w-[32px] max-h-[32px]  "
          />
          <p className="max-w-[200px] truncate text-[16px] font-semibold">
            {form?.name}
          </p>
        </div>
        <div className="flex gap-1 items-center">
          <button
            onClick={() => handleLink(form?.link)}
            className="flex flex-col w-fit justify-center items-center whitespace-nowrap  hover:bg-primary-100 px-1 my-1 text-dark rounded-md disabled:bg-secondary-30 disabled:text-black"
            disabled={linkIsValid}
            title={linkIsValid && "درانتظار تأیید ادمین"}>
            <img
              src="/images/chains.svg"
              alt="editIcon"
              className="white-img w-5 h-5 "
            />
          </button>
          <Link title="جزئیات" to={`/forms/${form?.id}`}>
            <img src={eyeIcon} alt="editIcon" className="white-img " />
          </Link>
        </div>
      </div>
      <div className="bg-white p-2 md:p-6  flex-center w-fit">
        {loadingQRImage ? (
          <div className="loader">
            <Loader />
          </div>
        ) : (
          <img
            src={qrCode}
            alt="QR Code"
            className="w-[150px] h-[150px] md:w-[200px] md:h-[200px]"
          />
        )}
      </div>

      <div className="mt-4  flex flex-col gap-1 items-center w-full">
        {formIsBanned && <p className="text-error-90">فرم مسدوداست</p>}
        {formIsExpired && form.expire_time && (
          <p className="text-error-90">فرم منقضی شده است</p>
        )}

        <div className="flex flex-col text-dark gap-4  w-full rounded-[16px] text-title-sm-regular">
          {form?.creation_time && (
            <div className="flex justify-between items-center gap-2 w-full">
              <label className="text-[12px]" htmlFor="">
                تاریخ ایجاد
              </label>
              <div className="flex gap-1">
                <div>{unixToPersianDay(form?.creation_time) ?? "-"}</div>
              </div>
            </div>
          )}
          {form?.expire_time && (
            <div className="flex justify-between items-center gap-2 w-full">
              <label className="text-[12px]" htmlFor="">
                تاریخ انقضا
              </label>
              <div className="flex gap-1 ">
                <div>{unixToPersianDay(form?.expire_time) ?? "-"}</div>
              </div>
            </div>
          )}
          {form?.fixed_amount && (
            <div className="flex justify-between items-center gap-2 w-full">
              <label className="text-[12px]" htmlFor="">
                مبلغ ثابت (ریال)
              </label>

              <p>{toLocaleStringFormatter(form?.form_amount) ?? "-"}</p>
            </div>
          )}
          {form?.has_target_amount && (
            <div className="flex justify-between items-center gap-2 w-full">
              <label className="text-[12px]" htmlFor="">
                مبلغ هدف (ریال)
              </label>

              <p>{toLocaleStringFormatter(form?.target_amount) ?? "-"}</p>
            </div>
          )}
          <div className="flex justify-between items-center gap-2 w-full">
            <label className="text-[12px]" htmlFor="">
              پرداخت‌کننده کارمزد
            </label>
            {form?.is_wage_on_owner === true ? <p>خودم</p> : <p>مشتری</p>}
          </div>
        </div>
      </div>
      <div className="flex gap-2 mt-auto flex-col w-full ">
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            وضعیت فرم
          </label>
          <ActiveFormCheckbox
            form={form}
            setFormStats={setFormStats}
            formStats={formStats}
          />
        </div>

        <div className="flex justify-between items-center w-full ">
          <FormStateCard status={formStats.status} active={formStats.active} />
          <div className="flex gap-1">
            <RWebShare
              data={{
                title: "فرم پرداخت",
                text: `Check out this payment form: ${form?.name}`,
                url: `${import.meta.env.VITE_FORM_URL}/f/${form?.link}`,
              }}
              onClick={() => console.log("shared successfully!")}>
              <button
                title="اشتراک"
                className="w-10 h-10 border p-1 flex-center rounded-lg hover:bg-[#CED3D9]">
                <img className="" src={shareIcon} alt="link-icon" />
              </button>
            </RWebShare>
            <PaymentLinkPrint id={form?.id} form={form} qrCode={qrCode} />
            <CopyButton
              copyText={`${import.meta.env.VITE_FORM_URL}/f/${form?.link}/` ?? "-"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentLinkCard2;

const CopyButton = ({ copyText }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(copyText);

    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1500); // Tooltip shows for 1.5 seconds
  };

  return (
    <div className="relative   flex ">
      <button
        title="کپی"
        onClick={(e) => handleCopy(e)}
        className=" hover:bg-[#CED3D9]   my-auto flex gap-2 p-2 border rounded-lg  items-center">
        <p className="text-[10px] md:text-[14px]">کپی کردن پیوند</p>
        <img
          src={copy}
          alt=""
          width={20}
          height={20}
          style={{ minWidth: "16px", minHeight: "16px" }}
        />
      </button>
      {showTooltip && (
        <div className="absolute   left-1/2 transform -translate-x-1/2 mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded">
          کپی{`\u202F`}شد
        </div>
      )}
    </div>
  );
};

const ActiveFormCheckbox = ({ form, setFormStats, formStats }) => {
  const [active, setActive] = useState(formStats?.active);
  const hadnleActiveForm = async () => {
    try {
      const response = await api.patch(`/forms/update/active/${form?.id}/`, {
        active_status: !formStats?.active,
      });

      if (response.status === 200) {
        setFormStats({
          status: response?.data?.approval_status,
          active: response?.data?.active,
        });
        toast.success(active ? "فرم غیرفعال گردید" : "فرم فعال گردید");
        setActive(!active);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="relative   flex ">
      <Switch
        value={active}
        onChange={() => hadnleActiveForm()}
        disabled={false}
      />
    </div>
  );
};

const FormStateCard = ({ active,status }) => {

  if (!active) {
    return (
      <div className=" px-[10px] py-1 rounded-md text-error-90 bg-error-10 text-title-sm-regular">
        موقتا غیرفعال
      </div>
    );
  }
  const statesArray = [
    {
      state: "pending",
      text: "در انتظار تایید",
      className:
        "text-[#CC8F14] bg-[#FFF0D1] px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
    {
      state: "approved",
      text: "تایید شده",
      className:
        " px-[10px] py-1 rounded-md text-success-60 bg-success-10 text-title-sm-regular",
    },
    {
      state: "denied",
      text: "رد شده",
      className:
        "text-error-90 bg-error-20 px-[10px] py-1 rounded-md  text-title-sm-regular",
    },
  ];

  const activeItem = statesArray.find(
    (item) => item.state === status,
  );

  return <div className={activeItem?.className}>{activeItem?.text}</div>;
};
